<template>
    <div class="w-full">
        <div class="w-full md:w-1/2 mx-auto">
            <div class="w-full h-64 mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Login Admin <br />RSUD Sultan Fatah
                </h1>
                <PersonLogin class="w-full h-full" />
            </div>
            <div>
                <form @submit.prevent="login" class="mt-24">
                    <FlashMessage class="mt-16 mb-3" />
                    <div class="w-full">
                        <TextInput
                            v-model="form.username"
                            :error="form.errors.username"
                            class="w-full"
                            id="username"
                            label="Username"
                            type="text"
                        />
                    </div>
                    <div class="w-full">
                        <TextInput
                            v-model="form.password"
                            :error="form.errors.password"
                            class="w-full"
                            id="Password"
                            label="password"
                            type="password"
                        />
                    </div>
                    <div style="border: 1px solid gray; margin-top: 10px; margin-bottom: 10px;"></div>
                    <button
                        class="bg-gray-400 hover:bg-gray-600 h-10 rounded-2xl w-[30%] text-white m-auto"
                        type="button"
                        @click.prevent="generateCaptcha()"
                    >
                        Refresh Captcha
                    </button>
                    <div class="w-full mt-2 flex gap-2 items-center">
                        <canvas id="valicode" class="w-[50%]"></canvas>

                        <TextInput
                            v-model="form.captcha"
                            :error="form.errors.captcha"
                            class="w-[50%]"
                            id="Captcha"
                            label="Captcha"
                            type="text"
                        />
                    </div>
                    <div class="w-full mt-5">
                        <button
                            type="submit"
                            class="bg-primary hover:bg-primary-dark h-16 rounded-3xl mt-8 w-full text-white m-auto"
                        >
                            LOGIN
                        </button>
                        <Link class="btn-secondary mt-3 w-full" href="/">
                            KE DAFTAR SULFAT
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../Shared/LayoutAdmin.vue";
import PersonLogin from "../../Shared/PersonLogin.vue";
import TextInput from "../../Shared/TextInput.vue";
import DateInput from "../../Shared/DateInput.vue";
import FlashMessage from "../../Shared/FlashMessage.vue";
export default {
    components: {
        PersonLogin,
        TextInput,
        DateInput,
        Link,
        FlashMessage,
    },
    layout: LayoutAdmin,
    data() {
        return {
            captcha: "",
            form: this.$inertia.form({
                username: "",
                password: "",
                captcha: "",
            }),
        };
    },
    mounted() {
        this.generateCaptcha();
    },
    watch: {
        "form.captcha"() {
            this.form.captcha = this.form.captcha.toUpperCase();
        },
    },
    methods: {
        generateCaptcha() {
            let showNum = [];
            let canvasWidth = 150;
            let canvasHeight = 30;
            let canvas = document.getElementById("valicode");
            if (canvas) {
                let context = canvas.getContext("2d");
                canvas.width = canvasWidth;
                canvas.height = canvasHeight;
                let sCode =
                    "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,0,1,2,3,4,5,6,7,8,9";
                let saCode = sCode.split(",");
                let saCodeLen = saCode.length;
                for (let i = 0; i <= 3; i++) {
                    let sIndex = Math.floor(Math.random() * saCodeLen);
                    let sDeg = (Math.random() * 30 * Math.PI) / 180;
                    let cTxt = saCode[sIndex];
                    showNum[i] = cTxt.toLowerCase();
                    let x = 10 + i * 20;
                    let y = 20 + Math.random() * 8;
                    context.font = "bold 23px 微软雅黑";
                    context.translate(x, y);
                    context.rotate(sDeg);

                    context.fillStyle = this.randomColor();
                    context.fillText(cTxt, 0, 0);

                    context.rotate(-sDeg);
                    context.translate(-x, -y);
                }
                for (let i = 0; i <= 5; i++) {
                    context.strokeStyle = this.randomColor();
                    context.beginPath();
                    context.moveTo(
                        Math.random() * canvasWidth,
                        Math.random() * canvasHeight
                    );
                    context.lineTo(
                        Math.random() * canvasWidth,
                        Math.random() * canvasHeight
                    );
                    context.stroke();
                }
                for (let i = 0; i < 30; i++) {
                    context.strokeStyle = this.randomColor();
                    context.beginPath();
                    let x = Math.random() * canvasWidth;
                    let y = Math.random() * canvasHeight;
                    context.moveTo(x, y);
                    context.lineTo(x + 1, y + 1);
                    context.stroke();
                }
                //   rightCode = showNum.join("");
                console.log(showNum.join(""));
                this.captcha = showNum.join("");
            }
        },
        randomColor() {
            let r = Math.floor(Math.random() * 256);
            let g = Math.floor(Math.random() * 256);
            let b = Math.floor(Math.random() * 256);
            return "rgb(" + r + "," + g + "," + b + ")";
        },
        login() {
            if (!this.form.captcha) {
                alert("Captcha tidak boleh kosong!");
                return;
            }
            if (this.captcha.toUpperCase() != this.form.captcha.toUpperCase()) {
                alert("Captcha masih salah!, silahkan cek kembali");
                return;
            }
            this.form.post("/auth/login", { preserveScroll: true });
        },
    },
};
</script>
